<app-header></app-header>
<div class="container-fluid">
  <div class="push-down">
    <ng-content></ng-content>
  </div>
</div>
<app-footer></app-footer>
